import { GuiListGeneric } from "../GuiListGeneric";
export class GuiListSupportBackgroundTask extends GuiListGeneric {
    constructor() {
        super("BackgroundTask");
    }
}
